<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  props: {
    id: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      mname: "patroltemplate",
      key: "id",
      url: {
        get: "/admin/system/template",
        add: "/admin/system/template",
        edit: "/admin/system/template",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "责任人",
          name: "maintainerId",
          value: "",
          type: "select",
          width: "240px",
          dropList: [],
        },
        {
          label: "巡检开始时间",
          name: "patrolBeginTime",
          value: "",
          type: "datetoday",
          rules: [{ required: true, message: "巡检开始时间不能为空",trigger: "blur" }],
        },
        {
          label: "巡检内容",
          name: "patrolContent",
          value: "",
          type: "textarea",
          width: "400px",
          rules: [{ required: true,message: "巡检内容不能为空", trigger: "blur" }],
        },
      ],
      forms: {
        id: "",
      },
    };
  },
  created() {
    this.loaduserData();
    if (this.id) {
      this.initData(this.id);
    }
  },
  methods: {
    initData() {
      // 加载详情数据
      let id = this.id;
      $utils.api.load(`/admin/system/template/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
        }
      });
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = {};
      if (!this.forms.maintainerId){
        $utils.toast.error("请选择责任人！");
        return
      }
      // q.id='';
      q.facilityList = this.forms.facilityList;
      q.maintainerId = this.forms.maintainerId;
      q.patrolBeginTime = this.forms.patrolBeginTime;
      q.patrolContent = this.forms.patrolContent;
      q.patrolName = this.forms.patrolName;
      q.timeUnit = this.forms.timeUnit;
      q.patrolDimension = this.forms.patrolDimension;
      q.patrolInterval = this.forms.patrolInterval;
      q.remark = this.forms.remark;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/patrol`, q, "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            });
        }
      });
    },
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.userId;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
  },
};
</script>
